import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute z-10 top-0 left-0 right-0 bottom-0 flex items-center justify-center py-20 bg-white rounded-xl p-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 animate-spin",
  viewBox: "0 0 100 100"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current opacity-40",
    cx: "50",
    cy: "50",
    r: "40"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current",
    "stroke-dasharray": "250",
    "stroke-dashoffset": "210",
    cx: "50",
    cy: "50",
    r: "40"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { useActivityStore } from "@/stores/activityStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingSpinnerComponent',
  setup(__props) {

const activityStore = useActivityStore();

return (_ctx: any,_cache: any) => {
  return (_unref(activityStore).loader.fetchActivityData === true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}
}

})